import { Alert, Button, PasswordInput, Stack } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { useState, type FormEvent, type ReactNode } from 'react';
import { api, izvedi } from '../api/odjemalec';
import { NapakaApi, sporocilo } from '../api/napaka';

/**
 * Obrazec za spremembo gesla (POST /api/seja/geslo) – za obvezno zamenjavo začasnega gesla in za spremembo iz
 * uporabniškega menija (kot ChangePasswordForm v Swingu). Napake strežnika se pokažejo ob polju (staroGeslo/novoGeslo).
 */
export function ObrazecGesla({
  oznakaStarega,
  gumb,
  ob,
  dodatno,
}: {
  oznakaStarega: string;
  gumb: string;
  ob: () => void;
  dodatno?: ReactNode;
}) {
  const [staro, setStaro] = useState('');
  const [novo, setNovo] = useState('');
  const [ponovi, setPonovi] = useState('');
  const [polja, setPolja] = useState<Record<string, string>>({});
  const [napaka, setNapaka] = useState<string | null>(null);
  const [posiljam, setPosiljam] = useState(false);

  const oddaj = async (e: FormEvent) => {
    e.preventDefault();
    setNapaka(null);
    setPolja({});
    if (novo !== ponovi) {
      setPolja({ ponovi: 'Novi gesli se ne ujemata.' });
      return;
    }
    setPosiljam(true);
    try {
      await izvedi(api.POST('/api/seja/geslo', { body: { staroGeslo: staro, novoGeslo: novo } }));
      ob();
    } catch (e) {
      if (e instanceof NapakaApi && Object.keys(e.polja).length > 0) {
        setPolja(e.polja);
      } else {
        setNapaka(sporocilo(e));
      }
    } finally {
      setPosiljam(false);
    }
  };

  return (
    <form onSubmit={(e) => void oddaj(e)} noValidate>
      <Stack gap="md">
        <PasswordInput
          label={oznakaStarega}
          value={staro}
          onChange={(e) => setStaro(e.currentTarget.value)}
          error={polja.staroGeslo}
          autoComplete="current-password"
          data-autofocus
          autoFocus
        />
        <PasswordInput
          label="Novo geslo"
          value={novo}
          onChange={(e) => setNovo(e.currentTarget.value)}
          error={polja.novoGeslo}
          autoComplete="new-password"
        />
        <PasswordInput
          label="Ponovite novo geslo"
          value={ponovi}
          onChange={(e) => setPonovi(e.currentTarget.value)}
          error={polja.ponovi}
          autoComplete="new-password"
        />
        {napaka && (
          <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} role="alert">
            {napaka}
          </Alert>
        )}
        <Button type="submit" fullWidth mt="sm" loading={posiljam}>
          {gumb}
        </Button>
        {dodatno}
      </Stack>
    </form>
  );
}
